import { FC, Key, useEffect } from 'react';
import { ProInput } from '../antd';
import SuperSelectTable from '../SuperSelectTable';
import { SuperSelectTableProps } from '../SuperSelectTable/interface';
import SimpleFormItem from './subpage/simpleFormItem';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { FormInstance } from 'antd/lib/form';
import { DEFAULT_FIELD_NAMES } from '../SuperSelect/interface';
import { NamePath } from '../constants/interface';

export interface SimpleFormSuperSelectTableProps extends Omit<BaseSimpleFormProps, 'name'> {
  labelKey?: string;
  valueKey?: string;
  /** 标签表单值 */
  labelValue?: any;
  superSelectTableProps?: SuperSelectTableProps;
  /** 是否自动创建label表单 */
  autoCreateLabelFormItem?: boolean;
  /** 表单字段名 */
  name?: NamePath | NamePath[];
}
const SimpleFormSuperSelectTable: FC<SimpleFormSuperSelectTableProps> = props => {
  const { disabledRender, superSelectTableProps, form, name, autoCreateLabelFormItem, labelValue, ...restProps } = props;
  let valueName: NamePath | undefined = '';
  let labelName: NamePath | undefined = '';
  if (Array.isArray(name)) {
    valueName = name[0];
    labelName = name[1];
  } else {
    valueName = name;
  }
  useEffect(() => {
    if (labelName) {
      form?.setFieldValue(labelName, labelValue);
    }
  }, [labelValue]);
  if (!superSelectTableProps) return null;
  const handleBeforeFetch = (params: any) => {
    if (!superSelectTableProps.beforeFetch) return params;
    const newParams = superSelectTableProps.beforeFetch?.(params);
    return newParams === undefined ? params : newParams;
  };
  const handleChange = (value: any, item: any, _?: FormInstance, index?: number) => {
    if (labelName) {
      if (superSelectTableProps.mode === 'multiple') {
        form?.setFieldValue(labelName, item?.map((v: any) => v[superSelectTableProps.labelKey || DEFAULT_FIELD_NAMES.label]));
      } else {
        form?.setFieldValue(labelName, item?.[superSelectTableProps.labelKey || DEFAULT_FIELD_NAMES.label]);
      }
    }
    superSelectTableProps.onChange?.(value, item, form, index);
  };
  
  return (
    <>
      <SimpleFormItem {...restProps} name={valueName}>
        <SuperSelectTable
          style={DEFAULT_STYLE}
          {...superSelectTableProps}
          disabledRender={disabledRender}
          beforeFetch={handleBeforeFetch}
          onChange={handleChange}
        />
      </SimpleFormItem>
      {!!labelName && (
        <SimpleFormItem
          hidden={true}
          name={labelName}
          style={{ padding: 0, margin: 0 }}
        >
          <ProInput />
        </SimpleFormItem>
      )}
    </>
  );
};

SimpleFormSuperSelectTable.displayName = SimpleFormItemEnum.SimpleFormSuperSelectTable;

export default SimpleFormSuperSelectTable;
